import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { getCurrentVariant } from '../../../../../helpers/getCurrentVariant';
import {
  getCurtainRailHexColour,
  getRollerHexColour,
} from '../../../../../helpers/getHexColorCode';
import { getPatternImages } from '../../../../../helpers/getPatternImages';

export const BackRollLightGuardRollerBlind = React.forwardRef(
  (
    props: React.SVGProps<SVGSVGElement>,
    setProductImageRef: React.Ref<SVGSVGElement>,
  ) => {
    const [state] = useService(productBuilderMachine);
    const patternUrl = getPatternImages(state);
    const currentVariant = getCurrentVariant(state.context);

    const currentProduct = currentVariant
      ? state.context.products.find(product =>
          product.variants.find(variant => variant.id === currentVariant.id),
        )
      : '';

    const bracketColourTag = currentProduct
      ? currentProduct.tags
          .find(tag => tag.includes('Bracket Colour'))
          ?.replace('Bracket Colour:', '')
      : '';

    const bracketColour =
      typeof bracketColourTag === 'string' && bracketColourTag !== ''
        ? bracketColourTag.trim()
        : 'Silver';

    const bracketColourHex = getRollerHexColour(bracketColour);

    const bottomRailColour = state.context.custom.bottomRailColour
      ? state.context.custom.bottomRailColour
      : 'Silver';

    const bottomRailColourHex = getRollerHexColour(bottomRailColour);

    const backRollBlockoutColour =
      state.context.custom.materialType === 'Blockout'
        ? 'white'
        : `url(#rollerFrontRollLightGuard)`;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        data-name="Layer 1"
        viewBox="0 0 554.33 420"
        {...props}
      >
        <defs>
          <pattern
            id="rollerFrontRollLightGuard"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <linearGradient
            id="prefix__linear-gradient"
            x1={13.45}
            y1={788.16}
            x2={547.15}
            y2={788.16}
            gradientTransform="translate(-3.13 -528.11)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.01} stopColor="#b7b8ba" />
            <stop offset={0.29} stopColor="#94989c" />
            <stop offset={0.65} stopColor="#bbbabe" />
            <stop offset={0.87} stopColor="#9a9ca0" />
            <stop offset={1} stopColor="#a3a5a8" />
            <stop offset={1} stopColor="#bfc2c6" />
          </linearGradient>
          <linearGradient
            id="prefix__linear-gradient-2"
            x1={280.2}
            y1={578.34}
            x2={280.2}
            y2={560.28}
            gradientTransform="translate(-3.13 -528.11)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.49} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.3} />
          </linearGradient>
          <linearGradient
            id="prefix__linear-gradient-3"
            x1={-450.3}
            y1={-691.22}
            x2={-450.3}
            y2={-709.28}
            gradientTransform="rotate(180 -86.565 -338.58)"
            xlinkHref="#prefix__linear-gradient-2"
          />
          <linearGradient
            id="prefix__linear-gradient-4"
            x1={-978.52}
            y1={138.89}
            x2={-978.52}
            y2={120.84}
            gradientTransform="translate(1255.68 -116.19)"
            xlinkHref="#prefix__linear-gradient-2"
          />
        </defs>
        <path
          fill={bracketColourHex}
          d="M0 0h14.55v409.05H0zM539.78 0h14.55v409.05h-14.55z"
        />
        <path
          fill="url(#rollerFrontRollLightGuard)"
          d="M10.32 256.1h533.7v7.9H10.32z"
        />
        <path
          fill="url(#rollerFrontRollLightGuard)"
          d="M10.02 4.6h534.09v252.6H10.02z"
        />
        <path
          fill={backRollBlockoutColour}
          d="M10.11 4.6h534.01v27.53H10.11z"
        />
        <path
          fill="url(#prefix__linear-gradient-2)"
          d="M10.02 32.13h534.09v18.1H10.02z"
        />
        <path
          fill="url(#prefix__linear-gradient-3)"
          d="M10.12 14.03h534.1v18.1H10.12v-18.1z"
        />
        <path
          fill="url(#prefix__linear-gradient-4)"
          d="M10.12 4.6h534.1v18.1H10.12z"
        />
        <path
          d="M535.21 0v.76h13.3V9h-1.24v9.4H546v-6.59a1.81 1.81 0 00-1.8-1.8v22.87a1.81 1.81 0 001.8-1.78v-6.47h2.49v4.76h2a.67.67 0 00.67-.68V0zM3.15 0v28.71a.67.67 0 00.68.68h2v-4.76h2.46v6.47a1.8 1.8 0 001.81 1.78V10a1.8 1.8 0 00-1.8 1.8v6.6H7.07V9H5.83V.76h13.3V0z"
          fill={bracketColourHex}
        />
      </svg>
    );
  },
);
